(function($) {


	var wow = new WOW(
      {
  		mobile: false
    }
    )
    wow.init();

	//universal vars
	var 	siteHeader = $('header.site-header'),
			backgroundwrapper = $('.background-wrapper'),
			scrollDistance = $(window).scrollTop();

	$(document).ready(function(){

		$('.section-header .action-link h3').each(function(){
		     var me = $(this);
		     me.html(me.html().replace(/^(\w+)/, '<span class="header-line">$1</span><br>'));
		});

		$('.testimonials-slider').slick({
		  dots: false,
		  infinite: true,
		  speed: 300,
		  slidesToShow: 1,
		  arrows: true,
		  //fade: true,
		  centerMode: true,
		  centerPadding: '100px',
		  responsive: [
			{
			  breakpoint: 768,
			  settings: {
			    //dots: true,
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
			   centerMode: false,
		  		centerPadding: '0px',
			  }
			}
			]
		});

		$('.homepage-slider').slick({
		  dots: false,
		  infinite: false,
		  speed: 1000,
		  slidesToShow: 1,
		  arrows: false,
		  adaptiveHeight: false,
		  autoplay: true,
		  fade: true,
		  appendArrows: $('.homepage-slide-arrows'),
		  appendDots:  $('.homepage-slide-dots'),
		  responsive: [
			{
			  breakpoint: 768,
			  settings: {
			    dots: true,
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
			   dots: false,
			  }
			}
			]
		});

		
		$('.homepage-logos').slick({
			dots: false,
			arrows: false,
			infinite: true,
			speed: 400,
			slidesToShow: 5,
			centerMode: false,
			autoplay: true,
			responsive: [
			{
			  breakpoint: 768,
			  settings: {
			    slidesToShow: 5
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
			    slidesToShow: 2,
			     centerMode: false,
			  }
			}
			]
		});

		$('.actions-slider').slick({
			dots: false,
			arrows: true,
			infinite: true,
			speed: 400,
			slidesToShow: 2,
			centerMode: false,
			autoplay: true,
			responsive: [
			{
			  breakpoint: 769,
			  settings: {
			    slidesToShow: 1,
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
			    slidesToShow: 1,
			    centerMode: true,
			  }
			}
			]
		});

		$('.posts-slider').slick({
			dots: false,
			arrows: true,
			infinite: true,
			speed: 400,
			slidesToShow: 3,
			centerMode: false,
			autoplay: true,
			responsive: [
			{
			  breakpoint: 769,
			  settings: {
			    slidesToShow: 2,
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
			    slidesToShow: 1,
			    centerMode: true,
			  }
			}
			]
		});

		$('.home div#eventer-dynamic-filters-area-121 ul.equah').slick({
			dots: false,
			arrows: false,
			infinite: false,
			speed: 400,
			slidesToShow: 3,
			centerMode: false,
			autoplay: true,
			responsive: [
			{
			  breakpoint: 769,
			  settings: {
			    slidesToShow: 2,
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
			    slidesToShow: 1,
			    centerMode: true,
			  }
			}
			]
		});

	//This option is for pages with a slider of images
	var lightbox = new SimpleLightbox('.image-gallery>.single-image>a', { /* options */ });
	var lightboxGrid = new SimpleLightbox('.image-gallery-grid>.single-image>a', { /* options */ });
	var lightboxGall = new SimpleLightbox('.image-gallery-header-slider>.single-image>a', { /* options */ });

		$('.image-gallery').slick({
		  arrows: true,
		  infinite: true,
		  dots: false,
		  speed: 300,
		  slidesToShow: 1,
		  centerMode: true,
		  variableWidth: true,
		  autoplay:true,
		  initialSlide: 0,
		  asNavFor: '.image-gallery-header-slider',
		  //appendArrows: $('.gallery-slide-arrows'),
		  //appendDots:  $('.gallery-slide-dots'),
		  focusOnSelect: true,
		  		responsive: [
			{
			  breakpoint: 769,
			  settings: {
			    //slidesToShow: 2,
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
			    arrows: false,
			    //slidesToShow: 3,
			  }
			}
			],
		});

		$('.image-gallery-header-slider').slick({
		  arrows: false,
		  infinite: true,
		  speed: 300,
		  slidesToShow: 1,
		  autoplay:true,
		  initialSlide: 0,
		  asNavFor: '.image-gallery',
		  fade: true,
		responsive: [
			{
			  breakpoint: 769,
			  settings: {
			    //slidesToShow: 2,
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
			    arrows: true,
			  }
			}
			],
		});




		//This will create a lightbox gallery to replace the default wordpress gallery
		 var galleryItems = $('figure.wp-block-gallery figure.wp-block-image');

		  galleryItems.each(function() {
		  
		  var   caption = $(this).find( "figcaption" ),
		        captionText = $(caption).text(),
		        link = $(this).find( "a" ),
		        image = $(this).find( "img" );
		  $(image).attr('title', captionText);


		  });
		   // Galleries on Project Pages

		   if($('figure.wp-block-gallery').length > 0) {
		      var lightbox = new SimpleLightbox('figure.wp-block-gallery figure.wp-block-image a', {
		        // captionSelector : 'figcaption',
		        // captionType : 'text'
		      });
		    }

		//hide events on homepage if empty 

		if($('.eventer-no-event-found').length > 0) {
			$('#homepage-events').hide();
		}
	});

	$(window).on('load',function() {

		sizeBoxes('.entry-excerpt');
		sizeBoxes('.post-wrapper .tm-title-wrapper');
		sizeBoxes('.actions .action-loop-lower h3');
		sizeBoxes('.posts-slider-even-titles');
		sizeBoxes('.posts-slider-even-excerpts');
		sizeBoxes('.single-testimonial');
		sizeBoxes('.link-box-text p');
		sizeBoxes('.link-box-text h3');

		

		// Animate loader off screen
	    $("#loader").fadeOut(300);
	});

	
	//scroll functions

	$(window).on('scroll',function() {
		scrollDistance = $(window).scrollTop();
		stickyHeaderClass(scrollDistance,50,siteHeader);
		if(scrollDistance > 100) {
			$('.booking-call-overlay').addClass('scrolled-call');
		}
		else {
			$('.booking-call-overlay').removeClass('scrolled-call');
		}
	});

	//sticky header function
	var stickyHeaderClass = function(scrollDistanceMonitor, classDistance, headerSelector){
		if(scrollDistanceMonitor > classDistance) {
			$(headerSelector).addClass('scrolled');
			$('.top-title img').fadeOut('slow', function(){
				$('.scroll-title img').fadeIn('slow', function() {
					$('.site-title img').addClass('scaled-title');

				});
			});	
		}
		else {
			$(headerSelector).removeClass('scrolled');
			$('.scroll-title img').fadeOut('slow', function(){
				$('.top-title img').fadeIn('slow', function() {
					$('.site-title img').removeClass('scaled-title');
				});
			});
		}
	};

	var sizeBoxes = function(boxSelector){
		var boxSize = 0;

		$(boxSelector).each(function(index){
			var heightSet = $(this).innerHeight();
			if(heightSet > boxSize) {
				boxSize = heightSet;
			}
		});
		//if($(window).width() > 767) {
			$(boxSelector).css('height', boxSize + 'px');
		//}
		console.log(boxSize);
	};


//open and close search menu
$('button.search-toggle').on("click", function (event) {
    event.preventDefault();
    $('body').toggleClass('search-open');
    event.stopPropagation();
});


$(document).on('click' , function(e){
    var $menu = $('.nav-primary'),
        $targetBody = $('body'),
        $menuButton = $('.menu-toggle'),
        $searchOverlayForm = $('.search-overlay-form'),
        $searchOverlay = $(".search-overlay"),
        $menuSearchButton = $('.menu-search a');

    // When the search menu is open this will close it on click outside form
    if (!$searchOverlayForm.is(e.target) // if the target of the click isn't the container...
    && $searchOverlayForm.has(e.target).length === 0 && !$menuSearchButton.is(e.target) && $targetBody.hasClass('search-open')) 
    // ... nor a descendant of the container

    {       event.preventDefault();
            $($targetBody).removeClass('search-open');
            event.stopPropagation();
    }
});

$(document).bind('keydown', function(e) {
	//alert(e.which);
    if (e.which == 27) {
        $('body').removeClass('search-open');
    }
}); 


//animate all anchor links

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth',
            block: "nearest", 
        });
    });
});

//this function os to animate numbers on the screen
if($('#counter-container').length > 0) {
	$(window).scroll(startCounter);

	function startCounter() {
	  let scrollY = (window.pageYOffset || document.documentElement.scrollTop) + window.innerHeight - 150;
	  let divPos = document.querySelector('#counter-container').offsetTop;

	  if (scrollY > divPos) {
	    $(window).off("scroll", startCounter);

	    $('.count').each(function() {
	      var $this = $(this);
	      jQuery({
	        Counter: 0
	      }).animate({
	        Counter: $this.text().replace(/,/g, '')
	      }, {
	        duration: 2000,
	        easing: 'swing',
	        step: function() {
	          $this.text(commaSeparateNumber(Math.floor(this.Counter)));
	        },
	        complete: function() {
	          $this.text(commaSeparateNumber(this.Counter));
	          //alert('finished');
	        }
	      });
	    });

	    function commaSeparateNumber(num) {
	      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	    }
	  }
	}
}

//this function is connected to the publications download
$('.toggle-download-form').on('click',function(event){
	var formTarget = $(this).siblings('.download-form-wrapper');

	event.preventDefault();
	return false;
	$('.download-form-wrapper').fadeOut(300);
	formTarget.fadeToggle(300);
	$('body').toggleClass('download-form-is-open');
});

$('button.hamburger').on('click',function(event){
	$(this).toggleClass('is-active');
});

$(window).on('load',function(){
	// $('.off-canvas ul.accordion-menu li').each(function(i){
	// 	var delay =(i + 1) / 6;
	// 	$(this).css('transition-delay', delay + 's' );
	// });
})

$(window).on('scroll',function(event){
	console.log(scrollDistance);

	var homepageSlideImages = $('.homepage-slider img');

	homepageSlideImages.each(function(index){
		$(this).css('transform','translateY('+ (scrollDistance / 2) +'px)')
	});
});

$('.gallery-image-button').on('click',function(event){
	$('.image-gallery .single-image.slick-active > a')[0].click();
	console.log('clicked');
});

$('.intro-read-more').on('click',function(event){
	var leading = $(this).siblings('.accommodation-intro');

	$(leading).toggleClass('show-all');
	$(this).toggleClass('more-visible');
	if($(this).hasClass('more-visible')) {
		$(this).html('- Read Less');
	}
	else {
		$(this).html('+ Read More');
	}
	
});
	
})( jQuery );